import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EarlyBirdDiscount } from '../interfaces/early-bird-discount';

@Injectable()
export class EarlyBirdDiscountCodeService {
  private _url = '/api/ClubDiscount/';

  constructor(private http: HttpClient) { }

  create(earlyBirdDiscount: EarlyBirdDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addearlybirddiscount', earlyBirdDiscount, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/early-bird-discount-code.service.ts